import { myAccountClient as client } from './axios-client';
import { getSvocId, getUserId, isB2CUser } from '../../utils/general';

export const B2C_ACCOUNT_PATH = '/b2b/user/account/b2c';
export const B2B_ACCOUNT_PATH = '/b2b/user/account';

let svocId = getSvocId();
let userId = getUserId();

export function fetchProfileData(success, error) {

  const url = isB2CUser()
    ? `${B2C_ACCOUNT_PATH}/${svocId}/profile`
    : `${B2B_ACCOUNT_PATH}/${userId}/customer/${svocId}/profile`;

  client.get(url)
    .then(success)
    .catch(error);
}

export function fetchAddressData(success, error) {
  const url = isB2CUser()
    ? `${B2C_ACCOUNT_PATH}/${svocId}/addresses`
    : `${B2B_ACCOUNT_PATH}/${userId}/customer/${svocId}/addresses`;

  client.get(url)
    .then(success)
    .catch(error);
}

export function fetchManagedAccountData(success, error) {
  const url = `${B2B_ACCOUNT_PATH}/${userId}/customer/${svocId}/perks/enrollments`;

  client.get(url)
    .then(success)
    .catch(error);

}
